import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "bootstrap-icons/font/bootstrap-icons.scss"
import "@progress/kendo-theme-bootstrap/dist/all.scss";
import store from "./store";

createApp(App).
use(store).
use(router).
mount("#app");
